import { useState } from "react";
import styles from "./StudentPage.module.css";
import StartScreen from "./Steps/StartScreen";
import StepSelect from "./Steps/StepSelect";
import StepAuthors from "./Steps/StepAuthors";
import StepConfirmation from "./Steps/StepConfirmation";

export default function StudentPage() {
    const [step, setStep] = useState(0);

    const [goal, setGoal] = useState(0);
    const [authors, setAuthors] = useState([""]);
    const [coAuthors, setCoAuthors] = useState([]);
    const [file, setFile] = useState(null);
    const [price, setPrice] = useState("");
    const [printedCopy, setPrintedCopy] = useState(false);

    const getBasePrice = () => {
        switch (goal) {
            case "edit": return 90;
            case "sole": return 100;
            case "group": return 120;
            default: return 100;
        }
    };

    const handleStepAuthorsNext = async ({ author, coAuthors, file, printedCopy, price, goal }) => {
        try {
            const formData = new FormData();
            formData.append("author", JSON.stringify(author));
            formData.append("coAuthors", JSON.stringify(coAuthors));
            formData.append("printedCopy", printedCopy);
            formData.append("goal", goal);
            formData.append("price", price);
            if (file) formData.append("file", file);

            const res = await fetch(`${process.env.REACT_APP_API_URL}/submissions`, {
                method: "POST",
                body: formData,
            });

            const data = await res.json();
            if (res.ok) {
                console.log("Article submitted:", data);
                setStep(3); // показать StepConfirmation
            } else {
                console.error("Error submitting article:", data);
            }
        } catch (err) {
            console.error("Network error:", err);
        }
    };

    return (
        <div className={styles.studentPage}>
            <header className={styles.header}>
                <div className={`${styles.header__container} _container`}>
                    <img
                        className={styles.header__logo1}
                        src="/images/logotype.jpg"
                        alt="ISM"
                    />
                    <div className={styles.header__text}>
                        <h2 className={styles.text__title}>
                            Eurasian Student Medical Journal
                        </h2>
                        <div className={styles.text__subtitle}>
              <span className={styles.text__subtitle}>
                ISSN(Print): 1694-8254
              </span>
                            <span className={styles.text__subtitle}>
                ISSN(Electronic): 1694-8297
              </span>
                        </div>
                    </div>
                </div>
            </header>
            <div className={`_container ${styles.student__content}`}>
                <aside className={styles.content__aside}>
                    <img src="/images/doi.png" alt="doi"/>
                    <img src="/images/ScienceIndex.jpg" alt="science index"/>
                    <img src="/images/Google_Scholar_logo.png" alt="google scholar"/>
                    <img src="/images/lic.jpg" alt="lic"/>
                </aside>

                <div className={styles.content__center}>
                    <>
                    {step === 0 && (
                        <StartScreen onStart={() => setStep(1)} />
                    )}

                    {step === 1 && (
                        <StepSelect
                            goal={goal}
                            setGoal={setGoal}
                            onNext={() => setStep(2)}
                        />
                    )}

                    {step === 2 && (
                        <StepAuthors
                            setPrintedCopy={setPrintedCopy}
                            printedCopy={printedCopy}
                            goal={goal}
                            onNext={handleStepAuthorsNext}
                            onBack={() => setStep(1)}
                        />
                    )}

                        {step === 3 && <StepConfirmation
                            goal={goal}
                            printedCopy={printedCopy}
                            price={getBasePrice()}
                            onOk={() => setStep(0)}
                        />}
                    </>
                </div>
                <aside className={styles.content__editor}>
                    <img src="/images/IMG_0052.jpg" alt="Editor"/>
                    <h4 className={styles.editor__subtitle}>
                        «Dear students, research work is the creation of intellectual
                        potential for clinical practice.»
                        <br/>
                        Head of the Student’s Research Sector at the International Higher
                        School of Medicine, PhD, MD Argen Alymkulov
                    </h4>
                </aside>
            </div>
            <footer className={`${styles.footer__container} _container`}>
                <div className={styles.footer__links}>
                    <p className={styles.links__title}>Interesting links</p>
                    <div className={styles.links__content}>
                        <a href="https://ocw.mit.edu/courses/11-233-crafting-research-questions-and-qualitative-methodology-fall-2005/?utm_source=chatgpt.com">Crafting
                            Research Questions and Qualitative Methodology</a>
                        <a href="https://www.coursera.org/courses?query=johns%20hopkins">Courses Johns Hopkins</a>
                        <a href="https://www.cochrane.org/learn/courses-and-resources/interactive-learning">Interactive
                            Learning</a>
                        <a href="https://methods.sagepub.com/#_">Sage</a>
                    </div>
                </div>
                <div className={styles.footer__articles}>
                    <p className={styles.articles__title}>New articles by our students</p>
                    <div className={styles.articles__content}>
                        <div className={styles.articles__cart}>
                            <img src="/images/atrial-myxoma-diagram-770x510.gif" alt="atrial myxoma"/>
                            <p className={styles.cart__text}>ARTICLES</p>
                            <a href="https://eamj-ism.kg/api/uploads/1754652328579-Dzhundubaev%20M.K.,%20Turgunov%20A.K,%20Ahmedova%20I.A,%20Inamullah,%20Areeba%20Sarfraz,0001.pdf"
                               className={styles.cart__title}>
                                FEATURES OF THE CLINICAL COURSE
                                AND OUTCOME OF SURGICAL
                                TREATMENT OF LEFT ATRIAL MYXOMA
                                IN A PATIENT WITH RECENT COVID-19
                                (case from practice)

                            </a>
                        </div>
                        <div className={styles.articles__cart}>
                            <img src="/images/fcvm-07-00137-g001.jpg" alt="AI IN CARDIO"/>
                            <p className={styles.cart__text}>ARTICLES</p>
                            <a href="https://eamj-ism.kg/api/uploads/1754652215836-Zhumadilova.pdf "
                               className={styles.cart__title}>THE ROLE OF AI IN CARDIOVASCULAR
                                DIAGNOSTICS</a>
                        </div>
                        <div className={styles.articles__cart}>
                            <img src="/images/ghfg.png" alt=""/>
                            <p className={styles.cart__text}>ARTICLES</p>
                            <a href="https://eamj-ism.kg/api/uploads/1754652825882-Clinical%20variants%20of%20the%20course%20of%20arterial%20hypertension%20in%20different%20population.pdf"
                               className={styles.cart__title}>Clinical variants of the course of arterial
                                hypertension in different population</a>
                        </div>
                        <div className={styles.articles__cart}>
                            <img src="/images/5f6091a0-20e2-405d-8859-6fbe60f4f8a3.png" alt=""/>
                            <p className={styles.cart__text}>ARTICLES</p>
                            <a href="https://eamj-ism.kg/api/uploads/1754652720682-Correlation%20between%20obesity%20and%20diabetic%20nephropathy%20among%20patients%20with%20type%202%20diabetes%20at%20Vedanta%20clinic,%20Bishkek..pdf"
                               className={styles.cart__title}>Correlation between obesity and diabetic
                                nephropathy among patients with type 2
                                diabetes at Vedanta clinic, Bishkek.</a>
                        </div>
                        <div className={styles.articles__cart}>
                            <img src="/images/ebdf0483-7592-49f9-93cf-f027f9f08be3.png" alt=""/>
                            <p className={styles.cart__text}>ARTICLES</p>
                            <a href="https://eamj-ism.kg/api/uploads/1762434195207-53_19%20Ð²ÑÐ¿ÑÑÐº%20Ð¸ÑÐ½Ñ%202025(2).pdf"
                               className={styles.cart__title}>THE HIDDEN MASTER GLAND: CLINICAL
                                INSIGHTS FROM A CASE OF
                                PANHYPOPITUITARISM</a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}
